<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation">
            <FormRow>
              <LazyCurrencySelector :currencies="['USD', 'CAD']" />
            </FormRow>
            <div>
              <AmountSelector :includeOther="true" />
              <ErrorLabel field="amount" />
            </div>
            <div class="frequency">
              <PaymentOptions addMonthly onlyMonthly />
            </div>
          </FormSection>
          <FormSection title="Designation">
            <FormRow inline>
              <FormCol field="applications.0.department" width="half" :showLabel="false">
                <FormSelect>
                  <option value="Yachad">Yachad</option>
                  <option value="Yachad_Baltimore">Yachad Baltimore</option>
                  <option value="Yachad_Chicago">Yachad Chicago</option>
                  <option value="Yachad_Cleveland">Yachad Cleveland</option>
                  <option value="Yachad_Israel">Yachad Israel</option>
                  <option value="Yachad_LosAngeles">Yachad Los Angeles</option>
                  <option value="Yachad_NewEngland">Yachad New England</option>
                  <option value="Yachad_NewYork">Yachad New York</option>
                  <option value="Yachad_NewJersey">Yachad New Jersey</option>
                  <!-- <option value="Greater Toronto">Greater Toronto</option> -->
                  <option value="Yachad_Florida">Yachad Florida</option>
                  <option value="Yachad_Toronto">Yachad Toronto</option>
                  <option value="Yachad_Summer">Yachad Summer</option>
                  <option value="Yachad_IVDU">IVDU</option>
                  <option value="Yachad_OurWay">Our Way</option>
                  <option value="Yachad_Reach">REACH</option>
                </FormSelect>
              </FormCol>
            </FormRow>
          </FormSection>
          <FormSection title="Personal Details">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.yachad.org/privacy-policy/"/>
                  </FormRow> 
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
            <FormRow>
              <Receipt :receipts="['canadian', 'us']" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { form, submit } = usePaymentForm();

    return {
      form,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
</style>
